import React from 'react';
import ReactDOM from 'react-dom';
import Demos from './Demos';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<Demos />, document.querySelector(".app"));
serviceWorker.unregister();